const formRouter = [
  {
    path: '/form/:id(\\d+)',
    name: 'FormDetail',
    component: () => import('@/views/form/detail')
  },
  {
    path: '/form/apply',
    name: 'FormApply',
    component: () => import('@/views/form/apply/index')
  },
  {
    path: '/form/apply/success',
    name: 'FormApplySuccess',
    component: () => import('@/views/form/apply/success')
  }
]

export default formRouter



// WEBPACK FOOTER //
// ./src/router/modules/form.js